"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Colors = {
    black: '#000000',
    charcoal: '#353f47',
    warmGrey: '#9b9b9b',
    porcelain: '#e2e6e9',
    whiteSmoke: '#f7f7f7',
    white: '#ffffff',
    monza: '#ba0118',
    maximumRed: '#C92413',
    carnation: '#F15A4B',
    cinnabar: '#EA3D2C',
    mangoTango: '#F2651F',
    zest: '#e4792e',
    sunglow: '#fecb39',
    goldenDream: '#eee82c',
    yellowCrayola: '#FEEB87',
    rossabel: '#FAE3CF',
    sandyBeach: '#FFE3B9',
    lightRed: '#FACFCF',
    springWood: '#FCFBF8',
    bianca: '#F9F5ED',
    cosmicLatte: '#FFFBE4',
    whiteRock: '#EEE8D8',
    goGreen: '#00AF66',
    forestGreen: '#169a3b',
    sushi: '#8CC63F',
    wildWillow: '#a1cd6d',
    berylGreen: '#BAE9B9',
    easternBlue: '#1387af',
    summerSky: '#26b6e8',
    charlotte: '#c7ecf9',
    lavender: '#F5D8FF',
    lavenderBlush: '#F0E2E2',
    byzantine: '#cc33aa',
    lavenderIndigo: '#9949FF',
    britishRacing: '#005229',
    deepForest: '#133121',
    edenred: '#E30613',
    edenredAlt: '#28C0D4',
    edenredAlt2: '#162056',
    swile: '#1e1147',
    swileAlt: '#fac6c1',
    swileAlt2: '#1e1147',
    up: '#FF960F',
    upAlt: '#FF960F',
    upAlt2: '#FF960F',
    pluxee: '#00EB5E',
    pluxeeAlt: '#221C46',
    pluxeeAlt2: '#221C46',
    bimpli: '#FFAA4D',
    bimpliAlt: '#0085F6',
    bimpliAlt2: '#000000',
    visa: '#353f47',
    visaAlt: '#1434CB',
    visaAlt2: '#1434CB',
};
exports.default = __assign(__assign({}, Colors), { success: Colors.goGreen, warning: Colors.zest, error: Colors.cinnabar, danger: Colors.cinnabar });
//# sourceMappingURL=Colors.js.map